import { GetItemPropsOptions } from "downshift";
import { HTMLAttributes, Key, memo, RefAttributes } from "react";
import { areEqual, ListChildComponentProps } from "react-window";
import { BaseOptionType, FormatOption, OptionSpreadProps } from "../../types";
import { stopPropagationHandler } from "../../utils";

export interface VirtualizedOptionProps<Option extends BaseOptionType> extends ListChildComponentProps {
    data: {
        getItemProps: (
            options: GetItemPropsOptions<Option>
        ) => HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement>;
        getOptionKey: (option: Option) => Key;
        getRenderedOption: FormatOption<Option>;
        highlightedIndex: number;
        isOptionSelected: boolean;
        metadata: {
            inputValue: string;
            isDisabled: boolean;
        };
        options: Option[];
    };
}

export const VirtualizedOption = memo(
    <Option extends BaseOptionType>({ data, index, style }: VirtualizedOptionProps<Option>) => {
        const { getItemProps, getRenderedOption, highlightedIndex, options, getOptionKey, isOptionSelected, metadata } =
            data;

        const option = options[index];
        const key = getOptionKey(option);
        return getRenderedOption(
            option,
            index,
            highlightedIndex,
            getItemProps({
                item: option,
                index,
                style: {
                    ...style,
                    width: "calc(100% - 16px)",
                },
                onClick: stopPropagationHandler,
                key,
            }) as OptionSpreadProps,
            isOptionSelected,
            metadata
        );
    },
    areEqual
);

VirtualizedOption.displayName = "VirtualizedOption";
